/* The shop checkout's payment and Pay (the Prints mockup's Payment fieldset, #payBtn and .secure), in the telify layer. */
@layer telify {
  .step {
    display: grid;
    gap: 14px;
  }

  .notice {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    font-size: 14.5px;
    color: var(--text-secondary);
  }

  .submit {
    margin-top: 20px;
  }

  .decline {
    margin-bottom: 14px;
    font-size: 14.5px;
    color: var(--danger);
  }

  .pay {
    width: 100%;
  }

  .pay:disabled {
    background: transparent;
    color: var(--text-muted);
    border-color: var(--border-soft);
    cursor: default;
  }

  .secure {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 12px;
    font-size: 13px;
    color: var(--text-tertiary);
    text-align: center;
  }
}
